export default {
    name: "Master Pages",
    meta: {
        icon: "supervised_user_circle",
        expanded: true,
        auth: true
    },
    departmentName: "Main Master",
    finalPagePermision: "",

    children: [
        // {
        //   name: "All Masters",
        //   path: "/master/viewAllMaster",
        //   meta: {

        //     // icon: "home",
        //     auth: true
        //   },
        //   component: require("../component/view/userManagement/viewAllMaster.vue"),
        //   finalPagePermision: "Client Master",
        // },
        {
            name: "System Configuration Master",
            keywords: ['System Master'],
            path: "/systemConfig",
            meta: {
                auth: true
            },
            component: require("../component/system/config.vue"),
            finalPagePermision: "System Configuration Master",
        },
        {
            name: "Client Details",
            keywords: ['Client Master'],
            path: "/client/viewClient",
            path: "/client/viewClient",
            meta: {
                //// icon: "group",
                auth: true
            },
            component: require("../component/view/clients/viewClient.vue"),
            finalPagePermision: "Client Master",
        },
        {
            name: "Client Department Details",
            permissionName: 'Department Master',
            keywords: ['Department Master'],
            path: "/client/department",
            meta: {
                auth: true,
                // icon: "check_box_outline_blank",
            },
            component: require("../component/view/clients/viewClientDept.vue"),
            finalPagePermision: "Client Department Details",
        },
        {
            name: "User Details",
            permissionName: 'User Management',
            keywords: ['User Management'],
            path: "/userManagement/viewUserDetail",
            meta: {
                // // icon: "person_add",
                auth: true
            },
            component: require("../component/view/userManagement/viewUserDetail.vue"),
            finalPagePermision: "User Management",
        },
        {
            name: "Client User",
            keywords: ['Client User'],
            path: "/client/user",
            meta: {
                icon: "person_add",
                auth: true
            },
            component: require("../component/clientUserMaster/clientUserList.vue"),
            finalPagePermision: "Client User",
        },
        {
            name: "Shipping Line Master",
            permissionName: 'Shipping Line Master',
            keywords: ['Shipping Line Master'],
            path: "/yard/shipping",
            meta: {
                //  // icon: "transfer_within_a_station",
                auth: true
            },
            component: require("../component/yard/shippingLineMaster.vue"),
            finalPagePermision: "Shipping Line Master",
        },
        {
            name: "Location Details",
            permissionName: 'Location Master',
            keywords: ['Location Master'],
            path: "/location/pickupLocation",

            meta: {
                //  // icon: "pin_drop",
                auth: true
            },
            component: require("../component/view/locationMaster/pickupLocation.vue"),
            finalPagePermision: "Location Master",
        },
        {
            name: "Sline Account Master",
            keywords: "",
            path: "/slineAcc",
            meta: {
                auth: true
            },
            component: require("../component/view/slinePaymentAccountMaster.vue"),
            finalPagePermision: "",
        },
        {

            name: " Container Details ",
            permissionName: 'Container Master',
            keywords: ['Container Master'],
            path: "/container/viewContainerType",
            meta: {
                auth: true,
                // icon: "check_box_outline_blank",
            },
            component: require("../component/view/containerMaster/viewContainerType.vue"),
            finalPagePermision: "Container Master",
        },
        {
            name: "Nature Of Expense Master",
            permissionName: 'Exp Inv Head Master',
            keywords: ['Exp Inv Head Master'],
            path: "/nature-of-expense",
            meta: {
                auth: true
            },
            component: require("../component/masters/natureOfExpenseMasters.vue"),
            finalPagePermision: "Exp Inv Head Master",
        },
        {
            name: "Exp Inv Head Master",
            permissionName: 'Exp Inv Head Master',
            keywords: ['Exp Inv Head Master'],
            path: "/billing/inv-exo-head",
            meta: {
                auth: true
            },
            component: require("../component/invoice/expInvHeads.vue"),
            finalPagePermision: "Exp Inv Head Master",
        },
        {
            name: "Agent & Coloader ",
            permissionName: 'Agent & Coloader Master',
            keywords: ['Agent & Coloader Master'],
            path: "/agentColoader/agentColoaderForm",
            meta: {
                // icon: "supervised_user_circle",
                auth: true
            },
            finalPagePermision: "Agent & Coloader Master",
            component: require("../component/freightForwarding/agentColoader/agentColoaderForm.vue")
        },
        {
            name: "Driver Details",
            permissionName: 'Driver Master',
            keywords: ['Driver Master'],
            path: "/vehicle/viewDriverDetail",
            meta: {
                //  // icon: "airline_seat_recline_extra",
                auth: true
            },
            component: require("../component/view/driverMaster/viewDriverDetail.vue"),
            finalPagePermision: "Driver Master",
        },
        {
            name: "Airline Master",
            permissionName: 'Airline Master',
            keywords: ['Airline Master'],
            path: "/airFreight/airlineMaster",
            meta: {
                //  // icon: "flight_takeoff",
                auth: true
            },
            component: require("../component/airFreight/airlineMaster.vue"),
            finalPagePermision: "Airline Master",
        },
        {
            name: "Vehicle Details",
            permissionName: 'Vehicle Master',
            keywords: ['Vehicle Master'],
            path: "/vehicle/viewVehicleDetail",
            meta: {
                // // icon: "local_shipping",
                auth: true
            },
            component: require("../component/view/vehicleMaster/viewVehicleDetail.vue"),
            finalPagePermision: "Vehicle Master",
        },
        {
            name: "Consignee Details",
            permissionName: 'Consignee Master',
            keywords: ['Consignee Master'],
            path: "/consigneeMaster",
            meta: {
                auth: true
            },
            component: require("../component/masters/consigneeMaster.vue"),
            finalPagePermision: "Consignee Master",
        },
        {
            name: "Consignor Details",
            permissionName: 'Consignor Master',
            keywords: ['Consignor Master'],
            path: "/consignorMaster",
            meta: {
                auth: true
            },
            //component: require("../component/masters/documentTypeMaster.vue"),
            component: require("../component/masters/consignorMaster.vue"), //consignorMaster.vue
            finalPagePermision: "Consignor Master",
        },
        {
            name: "Billing Location Master",
            permissionName: 'Billing Location Master',
            keywords: ['Billing Location Master'],
            path: "/billingLocMaster",
            meta: {
                // // icon: "person_add",
                auth: true
            },
            component: require("../component/masters/billingLocationMaster.vue"),
            finalPagePermision: "Billing Location Master",
        },
        {
            name: "Office Master",
            permissionName: 'Office Master',
            keywords: ['Office Master'],
            path: "/officeMaster",
            meta: {
                // // icon: "person_add",
                auth: true
            },
            component: require("../component/masters/officeMaster.vue"),
            finalPagePermision: "Office Master",
        },
        {
            name: "GST Location Master",
            permissionName: 'GST Master',
            keywords: ['Office Master'],
            path: "/gstMaster",
            meta: {
                // // icon: "person_add",
                auth: true
            },
            component: require("../component/masters/gstMaster.vue"),
            finalPagePermision: "GST Master",
        },
        {
            name: "Ledger Master",
            permissionName: 'Ledger Master',
            keywords: ['Ledger Master'],
            path: "/ledgerMaster",
            meta: {
                // // icon: "person_add",
                auth: true
            },
            component: require("../component/masters/ledgerMaster.vue"),
            finalPagePermision: "Ledger Master",
        },
        {
            name: "Package Details",
            permissionName: 'Package Master',
            keywords: ['Package Master'],
            path: "/pkgMaster",
            meta: {
                auth: true
            },
            component: require("../component/masters/pkgMaster.vue"),
            finalPagePermision: "Package Master",
        },
        {
            name: "Commodity Master New",
            permissionName: 'Commodity Master',
            keywords: ['Commodity Master', 'Commodity Master New'],
            path: "/freightForward/newcommodity",
            meta: {
                auth: true,
                // icon: "check_box_outline_blank",
            },
            component: require("../component/freightForwarding/newcommodityMaster.vue"),
            finalPagePermision: "Commodity Master",
        },
        {
            name: "Currency Details",
            permissionName: 'Currency Master',
            keywords: ['Currency Master'],
            path: "/currencyMaster",
            meta: {
                auth: true
            },
            component: require("../component/masters/currencyMasters.vue"),
            finalPagePermision: "Currency Master",
        },
 
        {
            name: "Charges Details",
            permissionName: 'Charges Master',
            keywords: ['Charges Master'],
            path: "/ChargesMaster",
            meta: {
                auth: true
            },
            
            //component: require("../component/masters/pagemoduleMaster.vue"),
            component: require("../component/masters/chargesMaster.vue"),
            finalPagePermision: "Charges Master",
        },
        {
            name: "Yard Condition ",
            permissionName: 'Yard Condition',
            keywords: ['Yard Condition'],
            path: "/yard/repairMainCondition",
            meta: {
                // icon: "transfer_within_a_station",
                auth: true
            },
            component: require("../component/yard/repairMainCondition.vue"),
            finalPagePermision: "Yard Condition",
        },
        {
            name: "Document Type",
            permissionName: 'Document Type',
            keywords: ['Document Type'],
            path: "/documentType",
            meta: {
                auth: true
            },
            component: require("../component/masters/documentTypeMaster.vue"),
            finalPagePermision: "Document Type", //
        },
         {
            name: "P&L Remarks",
            permissionName: 'Document Type',
            keywords: ['P&L Remarks'],
            path: "/masters/remarkMaster",
            meta: {
                auth: true
            },
            component: require("../component/masters/remarkMaster.vue"),
            finalPagePermision: "Document Type", //
        },
        {
            name: "Vendor Master",
            permissionName: 'Vendor Master',
            keywords: ['Vendor Master'],
            path: "/vendorMaster",
            meta: {
                auth: true
            },
            component: require("../component/masters/vendorMaster.vue"),
            finalPagePermision: "Vendor Master",
        },
        {
            name: "Vendor GST Master",
            permissionName: 'Vendor GST Master',
            keywords: ['Vendor Master'],
            path: "/vendorgstMaster",
            meta: {
                auth: true
            },
            component: require("../component/masters/vendorGstMaster.vue"),
            finalPagePermision: "Vendor Master",
            
        },



        {
            name: "Add Vehicle Type",
            path: "/vehicle/vehicleType",
            meta: {
                // icon: "local_shipping",
                auth: true
            },
            component: require("../component/view/vehicleMaster/vehicleType.vue"),
            finalPagePermision: "Vehicle Master",
        },
        {
            name: "Add Vehicle Size",
            path: "/vehicle/vehicleSize",
            meta: {
                // icon: "local_shipping",
                auth: true
            },
            component: require("../component/view/vehicleMaster/vehicleSize.vue"),
            finalPagePermision: "Vehicle Master",
        },

       
        // {
        //   name: "Air/Sea Port Details",
        //   path: "/location/airSeaPortLocation",

        //   meta: {
        //     //  // icon: "pin_drop",
        //     auth: true
        //   },
        //   component: require("../component/view/locationMaster/airSeaPortLocation.vue"),
        //   finalPagePermision: "Port Master",
        // },


   
        // {
        //   name: "Hub Details",
        //   path: "/vehicle/hubMaster",
        //   meta: {
        //     //// icon: "horizontal_split",
        //     auth: true
        //   },
        //   component: require("../component/view/vehicleMaster/hubMaster.vue"),
        //   finalPagePermision: "Hub Master",
        // },
      
        {
            name: "Mail Content",
            permissionName: 'Mail Master',
            keywords: ['Mail Master'],
            path: "/mailMaster/addMailContent",
            meta: {
                // // icon: "contact_mail",
                auth: true
            },
            component: require("../component/view/mailMaster/addMailContent.vue"),
            finalPagePermision: "Mail Master",

        },
        // {
        //   name: " Toll Charges Details",
        //   path: "/toll/viewtollCharges",
        //   meta: {
        //     // // icon: "departure_board",

        //     auth: true
        //   },
        //   finalPagePermision: "Toll Master",
        //   component: require("../component/view/tollMaster/viewtollCharges.vue")
        // },

        // {
        //   name: "Department Details",
        //   path: "/departmentMaster/department",
        //   meta: {
        //     auth: true,
        //     // icon: "group",
        //   },
        //   component: require("../component/view/departmentMaster/department.vue"),
        //   finalPagePermision: "Department Master",
        // },
   
        {
            name: " Vendor Details",
            permissionName: 'Vendor Master',
            keywords: ['Vendor Master'],
            path: "/vendorMaster/viewVendorMaster",
            meta: {
                // icon: "person_pin",
                auth: true
            },
            component: require("../component/view/vendorMaster/viewVendorMaster.vue"),
            finalPagePermision: "Vendor Master",

        },

        // {
        //   name: "Add Diesel Rate",
        //   path: "/diesel/dieselRate",
        //   meta: {
        //     // icon: "local_shipping",
        //     auth: true
        //   },
        //   component: require("../component/view/vehicleMaster/dieselRate.vue"),
        //   finalPagePermision: "Vehicle Master",
        // },
        {
            name: "Commodity Master",
            permissionName: 'Commodity Master',
            keywords: ['Commodity Master'],
            path: "/freightForward/commodity",
            meta: {
                auth: true,
                // icon: "check_box_outline_blank",
            },
            component: require("../component/freightForwarding/commodityMaster.vue"),
            finalPagePermision: "Commodity Master",
        },

        {
            name: "Ledger Details",
            permissionName: 'Ledger Master',
            keywords: ['Ledger Master'],
            path: "/LEDGERMASTER/ledgerMaster",
            meta: {
                // icon: "person_pin",
                auth: true
            },
            component: require("../component/view/LEDGERMASTER/ledgerMaster.vue"),
            finalPagePermision: "Ledger Master",

        },
        {
            name: "Module Details",
            permissionName: 'Module Master',
            keywords: ['Module Master'],
            path: "/moduleMaster",
            meta: {
                auth: true
            },
            component: require("../component/masters/moduleMaster.vue"),
            finalPagePermision: "Module Master",
        },
        {
            name: "Sub-Module Details",
            permissionName: 'Sub-Module Master',
            keywords: ['Sub-Module Master'],
            path: "/sub-moduleMaster",
            meta: {
                auth: true
            },
            component: require("../component/masters/submoduleMaster.vue"),
            finalPagePermision: "Sub-Module Master",
        },
        
        {
            name: "Page-Module Details",
            permissionName: 'Page-Module Master',
            keywords: ['Page-Module Master'],
            path: "/page-moduleMaster",
            meta: {
                auth: true
            },
            component: require("../component/masters/pagemoduleMaster.vue"),
            finalPagePermision: "Page-Module Master",
        },

        {
            name: "Email-Type Details",
            permissionName: 'Email-Type Master',
            keywords: ['Email-Type Master'],
            path: "/email-typeMaster",
            meta: {
                auth: true
            },
            component: require("../component/masters/emailtypeMaster.vue"),
            finalPagePermision: "Email-Type Master"
        },
        
        {
            name: "Email-User Details",
            permissionName: 'Email-User Master',
            keywords: ['Email-User Master'],
            path: "/email-userMaster",
            meta: {
                auth: true
            },
            component: require("../component/masters/emailuserMaster.vue"),
            finalPagePermision: "Email-User Master"
        },
    ]
};


// WEBPACK FOOTER //
// ./src/sidebar/allMaster.js